// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__31WsJ","disabled":"Button_disabled__2gkfu"};